import { render, staticRenderFns } from "./GoodsReport.vue?vue&type=template&id=6aa677d2&scoped=true"
import script from "./GoodsReport.vue?vue&type=script&lang=js"
export * from "./GoodsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa677d2",
  null
  
)

export default component.exports